import Button from "../../common/Button";
import Table from "../../common/Table";
import { notify } from "../../common/Toast";
import { salesOrderMaster } from "../../utlis/apiService";
import InputField from "../../common/InputField";
import { IoMdClose } from "react-icons/io";
import { FaPaperPlane } from "react-icons/fa";

const BatchTable = ({ batchItems, batchId, onClose }) => {
  const totalQty = batchItems.reduce(
    (sum, item) => sum + Number(item.qty || 0),
    0
  );
  const totalWeight = batchItems
    .reduce((sum, item) => sum + Number(item.qty_Weight || 0), 0)
    .toFixed(2);

  const columns = [
    { key: "order_No", label: "SO NO." },
    { key: "cust_Name", label: "Customer" },
    { key: "dieNumber", label: "Die No." },
    { key: "currentWeight", label: "Current Weight" },
    { key: "profile_Length", label: "Cut Length" },
    { key: "qty", label: "Pcs" },
    { key: "qty_Weight", label: "Weight" },
    { key: "alloy_Name", label: "Alloy" },
    { key: "req_Delivery", label: "Dispatch Date" },
    {
      key: "status",
      label: "Days to Dispatch",
    },
  ];

  const handleSendToProduction = async () => {
    try {
      const selectedIds = batchItems.map((item) => item.id);
      if (!selectedIds.length) {
        notify("No items in batch", "error");
        return;
      }
      await salesOrderMaster.SendToProdcution(selectedIds);
      onClose();
      notify("Batch sent to production successfully!", "success");
    } catch (error) {
      console.error("SendToProduction Error:", error);
      notify("Failed to send batch to production", "error");
    }
  };
  return (
    <div className="fixed inset-0 bg-slate-800 bg-opacity-75 flex items-center justify-center p-2 sm:p-4 z-9999">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[95vh] overflow-y-auto">
        <div className="flex justify-between bg-primary text-white items-center p-4 sm:p-4">
          <h2 className="text-xl font-semibold uppercase ">
            Current Production Batch Sheet
          </h2>
          <Button
            className="text-white text-md font-semibold rounded-md p-2"
            onClick={onClose}
            icon={IoMdClose}
            iconSize="w-6 h-6"
          />
        </div>
        <div className="p-4 sm:p-2">
          <Table columns={columns} data={batchItems} showActions={false} />
          <div className="bg-slate-100 px-4 py-3 mt-2 text-sm font-semibold flex justify-between text-slate-700 rounded-md shadow-inner">
            <span>TOTALS:</span>
            <div className="flex gap-6">
              <span>Total Qty: {totalQty} pcs</span>
              <span>Total Weight: {totalWeight} kg</span>
            </div>
          </div>
          <div className="mt-6 border-t pt-4">
            <h3 className="text-md font-semibold mb-2">
              Finalize and Send Batch to Production
            </h3>
            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Next Production Batch ID:
              </label>
              <InputField value={batchId} disabled placeholder="0" />
            </div>

            <Button
              text="Send to Production"
              className="text-black font-semibold font-semibold rounded-md bg-orange p-2"
              icon={FaPaperPlane}
              iconSpacing="pr-2"
              onClick={handleSendToProduction}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatchTable;
